// src/dashboard/reducers/metrics.js
import {
  FETCH_METRIC_REQUEST,
  FETCH_METRIC_SUCCESS,
  FETCH_METRIC_FAILURE,
} from "../actions/metrics";

const initialState = {}; // { [name]: { data, status, error, fetchedAt, filtersKey } }
const entry = (state, name) => state[name] || { data: null, status: "idle", error: null, fetchedAt: 0, filtersKey: null };

export default function metricsReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_METRIC_REQUEST: {
      const { name } = action.payload;
      return {
        ...state,
        [name]: { ...entry(state, name), status: "loading", error: null },
      };
    }
    case FETCH_METRIC_SUCCESS: {
      const { name, filtersKey, data } = action.payload;
      return {
        ...state,
        [name]: { data, status: "success", error: null, fetchedAt: Date.now(), filtersKey },
      };
    }
    case FETCH_METRIC_FAILURE: {
      const { name, error } = action.payload;
      return {
        ...state,
        [name]: { ...entry(state, name), status: "error", error },
      };
    }
    default:
      return state;
  }
}
